import getAppName from '../getAppName';
/**
 * 当前系统
 */
const getOsName = function () {
    const ua = navigator.userAgent;
    let platform = 'other';
    // 检测平台环境
    if (/iP(hone|ad)/.test(ua)) {
        platform = 'ios';
    }
    else if (/Android/.test(ua)) {
        platform = 'android';
    }
    else if (/Windows/.test(ua)) {
        platform = 'windows';
    }
    return platform;
};
const getLanguage = function () {
    return navigator.userAgent.match(/locale\/([\S]+)/)?.[1] ?? '';
};
export default function () {
    // TODO: 完善端外情况
    return {
        isMobile: /Mobile/i.test(navigator.userAgent),
        appName: getAppName(),
        platform: getOsName(),
        language: getLanguage(),
        isOverseas: /isOverseas/i.test(navigator.userAgent) ||
            window.location.hostname.indexOf('kittyfunny.com') > -1,
    };
}
